import React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './PartnerApiPage.module.scss';
import clsx from 'clsx';
import Layout from '../Layout/Layout';
import SimpleContent from '../SimpleContent/SimpleContent';
import Link from '../Link/Link';
import Block from '../Block/Block';
import Code from '../Code/Code';
const PartnerApiPage = () => {
  const data = [
    {
      name: 'Авторизация',
      content: (
        <>
          <p>
            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ipsam, harum incidunt. Perspiciatis illum consectetur exercitationem iure, perferendis laborum eum quas! <span>private key</span>
            <Code>qwerfalskjdflksdjfl;kadsjf;lkj</Code>
            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Eveniet saepe quibusdam blanditiis repellat nesciunt aliquid veritatis, officia maiores placeat temporibus ex assumenda pariatur consequatur nulla! Minus, animi. Nihil aliquid facilis incidunt, eaque, vel pariatur corrupti dolore
            nam ut nemo similique placeat fugiat dicta neque sequi mollitia alias beatae? Ducimus sunt, harum quo minus molestiae eaque labore dolorum nam iure? Qui soluta non eaque voluptatem temporibus tempore quis maxime ab, quam quae ipsum. Reiciendis aperiam tenetur cum ab vero, quam in facere
            eaque. Dolor illum perspiciatis porro quos. Molestias aliquam asperiores architecto reprehenderit iusto, reiciendis distinctio cupiditate laudantium beatae, explicabo itaque.
          </p>
        </>
      ),
    },
    {
      name: 'Описание API ',
      list: [
        {
          name: (
            <>
              Создание тразакации <span>POST /transation/create</span>
            </>
          ),

          content: (
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Deleniti expedita distinctio iure dicta ullam est, aut velit vitae quam accusamus dolorem asperiores, alias assumenda explicabo, earum quas similique recusandae commodi impedit accusantium ipsa rerum deserunt. Officia, iusto
              impedit ea at nesciunt odit recusandae saepe provident? Rem eum distinctio porro amet, ad sit nesciunt, veritatis eaque eius earum quisquam libero sint asperiores ipsum veniam dolor odit temporibus facere quibusdam magnam dolorem ipsa id deleniti ducimus. Aut, odit. Itaque sint beatae
              delectus sit reprehenderit? Deserunt, id facere impedit fugiat nemo beatae consequuntur cumque ab quos assumenda nulla quas commodi pariatur nisi placeat!
            </p>
          ),
        },
        {
          name: (
            <>
              Изменение статуса тразакации <span>POST /transation/status</span>
            </>
          ),
          content: (
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Deleniti expedita distinctio iure dicta ullam est, aut velit vitae quam accusamus dolorem asperiores, alias assumenda explicabo, earum quas similique recusandae commodi impedit accusantium ipsa rerum deserunt. Officia, iusto
              impedit ea at nesciunt odit recusandae saepe provident? Rem eum distinctio porro amet, ad sit nesciunt, veritatis eaque eius earum quisquam libero sint asperiores ipsum veniam dolor odit temporibus facere quibusdam magnam dolorem ipsa id deleniti ducimus. Aut, odit. Itaque sint beatae
              delectus sit reprehenderit? Deserunt, id facere impedit fugiat nemo beatae consequuntur cumque ab quos assumenda nulla quas commodi pariatur nisi placeat!
            </p>
          ),
        },
        {
          name: 'Создание тразакации (POST /transation/create)',
          content: (
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Deleniti expedita distinctio iure dicta ullam est, aut velit vitae quam accusamus dolorem asperiores, alias assumenda explicabo, earum quas similique recusandae commodi impedit accusantium ipsa rerum deserunt. Officia, iusto
              impedit ea at nesciunt odit recusandae saepe provident? Rem eum distinctio porro amet, ad sit nesciunt, veritatis eaque eius earum quisquam libero sint asperiores ipsum veniam dolor odit temporibus facere quibusdam magnam dolorem ipsa id deleniti ducimus. Aut, odit. Itaque sint beatae
              delectus sit reprehenderit? Deserunt, id facere impedit fugiat nemo beatae consequuntur cumque ab quos assumenda nulla quas commodi pariatur nisi placeat!
            </p>
          ),
        },
      ],
    },
    {
      name: 'Еще один пункт меню',
    },
  ];
  return (
    <>
      <SimpleContent title="API документация">
        <div className={clsx(styles.list)}>
          {data?.map((item) => (
            <>
              <div className={clsx(styles.linkWrap)}>
                <Link className={clsx(styles.link)}>{item?.name}</Link>
              </div>
              {item?.list?.length && (
                <div className={clsx(styles.list, styles.subList)}>
                  {item?.list?.map((subItem) => (
                    <Link className={clsx(styles.link, styles.subLink)}>{subItem?.name}</Link>
                  ))}
                </div>
              )}
            </>
          ))}
        </div>
      </SimpleContent>
      {data?.map((item) => (
        <SimpleContent title={item?.name} className={clsx(styles.block)}>
          {item?.content}
          {item?.list?.map((subItem) => (
            <SimpleContent>
              <div className={clsx(styles.subTitle)}>{subItem?.name}</div>
              {subItem?.content}
            </SimpleContent>
          ))}
        </SimpleContent>
      ))}
    </>
  );
};

export default PartnerApiPage;
